import { SendFeedbackContainer } from 'owa-addins-core';
import { LazyImport, LazyModule } from 'owa-bundling';
import sendFeedbackCallback from 'owa-mail-addins/lib/utils/createSendFeedbackCallback';

export { default as readItemSupportsAddins } from './utils/ReadItemSupportsAddins';
export { default as runAfterNotificationSetup } from './utils/runAfterNotificationSetup';
export { default as makePinRequest } from './operations/makePinRequest';
export { default as migratePersistedAddins } from './operations/migratePersistedAddins';
export { default as updateAddinOnItemNavigation } from './utils/updateAddinOnItemNavigation';
export {
    default as updateAddinOnNavigationToEmptyNullReadingPane,
} from './utils/updateAddinOnNavigationToEmptyNullReadingPane';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Addins" */ './lazyIndex'));

export const lazyHasInlineImage = new LazyImport(lazyModule, m => m.hasInlineImage);
export const lazyCreateMailReadAdapter = new LazyImport(lazyModule, m => m.createMailReadAdapter);
export const lazyCreateMailComposeAdapter = new LazyImport(
    lazyModule,
    m => m.createMailComposeAdapter
);

SendFeedbackContainer.sendFeedback = sendFeedbackCallback;
